import { apiGet, apiPost, apiPut } from '@api/api.utils'
import { IResponseAddressSuggestions, IResponseCommon } from "../common.types"
import { IFinalityFilter } from "./state.types"
import {
    IResponseFinalityCardData,
    IResponseFinalityFilesList,
    IResponseFinalityPrimaryList,
    IResponseFinalityTrackNumbers,
    IResponsePaymentFilesOnContract,
} from "./api.types"


const route = '/finality'

export const getDeliveryAddressSuggestions = (query: string, signal?: AbortSignal): Promise<IResponseAddressSuggestions> =>
    apiPost<IResponseAddressSuggestions>(`${route}/getDeliveryAddressSuggestions`, { signal }, { query })


/** Основной список */
export const getFinalityList = (pageNumber: number, search?: string, filter?: IFinalityFilter, signal?: AbortSignal): Promise<IResponseFinalityPrimaryList> =>
    apiGet<IResponseFinalityPrimaryList>(`${route}/getFinalityList`, { params: { pageNumber, search, filter }, signal })



/** Данные по анкете */
export const getFinalityCardData = (contractID: number): Promise<IResponseFinalityCardData> =>
    apiGet<IResponseFinalityCardData>(`${route}/getFinalityCardData`, { params: { contractID } })
/** Список файлов по анкете */
export const getFinalityFilesList = (contractID: number): Promise<IResponseFinalityFilesList> =>
    apiGet<IResponseFinalityFilesList>(`${route}/getFinalityFilesList`, { params: { contractID } })
/**  Список трек-номеров по анкете */
export const getFinalityTrackNumbersList = (contractID: number): Promise<IResponseFinalityTrackNumbers> =>
    apiGet<IResponseFinalityTrackNumbers>(`${route}/getFinalityTrackNumbersList`, { params: { contractID } })
/** Создание/Редактирование трэк-номеров по анкете */
export const saveFinalityTrackNumber = (
    contractID: number,
    deliveryID: number,
    action: string,
    trackNumber: string,
    trackNumberComment: string
): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/saveFinalityTrackNumber`, {
        params: { contractID, deliveryID, action, trackNumber, trackNumberComment },
    })
/** Сохранение данных по анкете */
export const saveFinalityCardData = (
    contractID: number,
    deliveryToWhom: string,
    deliveryAddress: string,
    myComment: string,
    isAddressConfirmed: number,
    isDeliveryCDEK: number
): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/saveFinalityCardData`, {
        params: { contractID, deliveryToWhom, deliveryAddress, myComment, isAddressConfirmed, isDeliveryCDEK },
    })



/** Список файлов счетов по договору */
export const getPaymentFilesOnContract = (contractID: number): Promise<IResponsePaymentFilesOnContract> =>
    apiGet<IResponsePaymentFilesOnContract>(`${route}/getPaymentFilesOnContract`, { params: { contractID } })



/** Отправка информации в telegram канал (ИКТ - Сканы дипломов) */
export const telegramFinalitySendingFiles = (contractListenerID: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/telegramFinalitySendingFiles`, { params: { contractListenerID } })
/** Завершение обучения и отправка информации в telegram канал (ИКТ - Доставка) */
export const telegramFinalitySendingEndCloseContract = (contractID: number, byTrackNumber: string, skipStatusUpdate?: boolean): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/telegramFinalitySendingEndCloseContract`, { params: { contractID, byTrackNumber, skipStatusUpdate } })

/** Отправка счёта в канал срочных сообщений сайта договора */
export const telegramPaymentInvoiceToClint = (
    contractID: number,
    paymentInvoiceType: number,
    namefilesToSend: string[]
): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(
        `${route}/telegramPaymentInvoiceToClint`,
        { params: { contractID, paymentInvoiceType } },
        { namefilesToSend }
    )
/** Отправка заявления на доставку в канал срочных сообщений сайта договора */
export const telegramApplicationDeliveryToClient = (contractID: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/telegramApplicationDeliveryToClient`, { params: { contractID } })